import React from "react";

import { Image } from "../components/media";

export default function ClientTopBarMobile() {
  return (
    <div className="topbar-mobile">
      <div className="row align-items-center">
        <div className="col-md-12">
          <div className="mobile-logobar">
            <a href="index.html" className="mobile-logo">
              <Image src="logo.png" />
            </a>
          </div>
          <div className="mobile-togglebar">
            <ul className="list-inline mb-0">
              <li className="list-inline-item">
                <div className="topbar-toggle-icon">
                  <a className="topbar-toggle-hamburger" href="#!">
                    <Image
                      src="svg-icon/horizontal.svg"
                      className="img-fluid menu-hamburger-horizontal"
                    />

                    <Image
                      src="svg-icon/verticle.svg"
                      className="img-fluid menu-hamburger-vertical"
                    />
                  </a>
                </div>
              </li>
              <li className="list-inline-item">
                <div className="menubar">
                  <a className="menu-hamburger" href="#!">
                    <Image
                      src="svg-icon/collapse.svg"
                      className="img-fluid menu-hamburger-collapse"
                    />

                    <Image
                      src="svg-icon/close.svg"
                      className="img-fluid menu-hamburger-close"
                    />
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
